Ext.define('SA.view.menu.AddToCombinationLocation', {
    alias: 'widget.menu-add-to-combination-location',
    extend: 'Ext.menu.Item',

    bubbleEvents: ['create:comboLocation'],
    text: 'Add to Combination Location',

    menu: {
        cls: 'sa-menu-compact'
    },

    beforeMenuShow() {
        this.refresh();
    },

    getLocation() {
        return this.location;
    },

    getViableCombinations() {
        var id = this.getLocation(),
            geographicUnit = SA.data.LocationsCache.get(id).geographicUnit,
            combos = SA.data.CustomLocations.getAllCombinations();

        return combos.filter(combo => {
            var firstLocation = SA.data.LocationsCache.get(combo.locationSeries[0]);

            return firstLocation.geographicUnit === geographicUnit;
        });
    },

    refresh() {
        var menu = this.menu,
            combos = this.getViableCombinations(),
            locationId = this.getLocation(),
            isCustom = SA.data.LocationsCache.isCustomLocation(locationId),
            visible = !isCustom && locationId !== SA.AppController.getCurrentCountry().getLocationSeries();

        Ext.suspendLayouts();

        menu.removeAll();

        menu.add({
            text: 'Create New Combination',

            handler: () => {
                Ext.widget({
                    xtype: 'create-combination-location',
                    locationSeries: [locationId],

                    callback: combo => {
                        this.fireEvent('create:comboLocation', combo);
                    }
                });
            }
        });

        if (combos.length) {
            menu.add({xtype: 'menuseparator'});
        }

        combos.forEach(combo => {
            menu.add({
                text: combo.name,

                handler() {
                    SA.data.CustomLocations.appendSeries(combo, locationId);
                }
            });
        });

        this.setVisible(visible);

        Ext.resumeLayouts(true);
    }
});